import { Flex, Heading, Button, Text, GridItem, Input, Box, FormControl, FormLabel, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Link } from '@chakra-ui/react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import SettingsBreadcrumb from '../../../components/SettingsBreadcrumb';
import CustomInput from '../../../components/common/Input/input';
import * as api from '../../../api/redesSociais';
import Swal from 'sweetalert2';
import { HelpCircle } from 'lucide-react';
import HelpGuideModal from '../../../components/GuiaDeAjuda/GuiaDeAjuda';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebookSquare, faInstagram, faLinkedin, faYoutube,
  faTiktok, faXTwitter, faWhatsapp, faTelegram, faTumblrSquare
} from '@fortawesome/free-brands-svg-icons';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';

function ConfigurarMidia() {
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean>(false);
  const [isHelpModalOpen, setIsHelpModalOpen] = useState<boolean>(false);
  const navigate = useNavigate();
  const location = useLocation();

  const { descricaoRede } = location.state;
  const { codigoRede } = location.state;

  const [formValues, setFormValues] = useState({
    dscUsuario: {
      value: '',
      error: false
    },
    dscTokenAcesso: {
      value: '',
      error: false
    },
    dscSenha: {
      value: '',
      error: false
    },
    dscChaveApi: {
      value: '',
      error: false
    },
    dscPaginaId: {
      value: '',
      error: false
    },
    dscEndpoint: {
      value: '',
      error: false
    }
  })

  const tituloRede = (codigo: number) => {
    const titles: { [key: number]: string } = {
      0: 'Facebook',
      1: 'Instagram',
      2: 'LinkedIn',
      3: 'Youtube',
      4: 'TikTok',
      5: 'X (Antigo Twitter)',
      6: 'Whatsapp',
      7: 'Telegram',
      8: 'Tumblr',
      9: 'Página Internet',
    };

    return titles[codigo] || '';
  };

  const iconeRedeSocial = (id: number) => {
    const icones: { [key: number]: { icon: any, color: string } } = {
      0: { icon: faFacebookSquare, color: "#1789fc" },
      1: { icon: faInstagram, color: "#ec1393" },
      2: { icon: faLinkedin, color: "#1DA1F2" },
      3: { icon: faYoutube, color: "#ff0000" },
      4: { icon: faTiktok, color: "#080404" },
      5: { icon: faXTwitter, color: "#080404" },
      6: { icon: faWhatsapp, color: "#43e460" },
      7: { icon: faTelegram, color: "#088ccc" },
      8: { icon: faTumblrSquare, color: "#384c5c" },
    };

    return icones[id] || { icon: faGlobe, color: "#3b87d8" };
  };

  const isFormValid = () => { 
    const { dscUsuario, dscTokenAcesso, dscPaginaId } = formValues;

    // Campos obrigatórios básicos para todas as redes
    const camposBasicosValidos = dscUsuario.value.trim() && dscTokenAcesso.value.trim();

    // Para Instagram e Facebook, Page ID/User ID é obrigatório
    if (descricaoRede === 'Instagram' || descricaoRede === 'Facebook') {
      return camposBasicosValidos && dscPaginaId.value.trim();
    }

    // Para outras redes (incluindo TikTok), apenas os campos básicos são obrigatórios
    return camposBasicosValidos;
  };

  const handleFieldChange = (field: string, value: string) =>
    setFormValues({
      ...formValues,
      [field]: {
        error: false,
        value
      }
    })

    const handleSubmit = async () => {
      const { dscUsuario } = formValues;
      const { dscTokenAcesso } = formValues;
      const { dscSenha } = formValues;
      const { dscChaveApi } = formValues;
      const { dscPaginaId } = formValues;
      const { dscEndpoint } = formValues;
  
      const params = {
        codRede: codigoRede,
        sitRegistro: 1,
        dscUsuario: dscUsuario.value || null,
        dscSenha: dscSenha.value || null,
        dscTokenAcesso: dscTokenAcesso.value || null,
        dscChaveApi: dscChaveApi.value || null,
        dscPaginaId: dscPaginaId.value || null,
        dscEndpoint: dscEndpoint.value || null,
      };
      
      try {
        await api.inserirContaRedeSocial(params);
        // setIsSuccessModalOpen(true);
        Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          text: 'Rede Social adicionada com sucesso.',
        }).then(() => {
          navigate(-1)      
        });
      } catch (error) {
        console.error('Erro ao adicionar rede social:', error);
  
        Swal.fire({
          icon: 'error',
          title: 'Erro!',
          text: 'Erro ao adicionar rede social. Tente novamente mais tarde.',
        }).then(() => {
          setIsSuccessModalOpen(false);
        });
      }
    };

  const openHelpModal = () => setIsHelpModalOpen(true);
  const closeHelpModal = () => setIsHelpModalOpen(false);

  return (
    <Flex p="40px" bgColor="#fafafa" direction="column" w="100%">
    <SettingsBreadcrumb />
    <Flex
      direction={{ base: "column", md: "row" }}
      alignItems="center"
      justifyContent="space-between"
      w="100%"
      mb="20px"
    >
      <Heading
        mt="30px"
        fontWeight="600"
        fontSize="21px"
        color="#6F6F6F"
      >
        Configurar Rede Social
      </Heading>
      <Flex
        hidden={
          descricaoRede != 'Linkedin' &&
          descricaoRede != 'Instagram' && 
          descricaoRede != 'Facebook'
        }
        mt="30px"
        ml={{ base: 0, md: 4 }}
        alignItems="center"
        cursor="pointer"
        onClick={openHelpModal}
      >
        <Text
          ml="0.5rem"
          color="#1789fc"
          fontSize="md"
          textDecoration="underline"
          display="inline-flex"
          alignItems="center"
          _hover={{
            color: '#1468C9',
          }}
        >
          <HelpCircle size={18} color="#1789fc" />
          <span style={{ marginLeft: "0.5rem" }}>
            Precisa de ajuda para configurar?
          </span>
        </Text>
      </Flex>
    </Flex>
      <Heading
        mb="25px"
        fontWeight="500"
        fontSize="21px"
        w="100%"
      >
        <FontAwesomeIcon
          style={{ marginRight: '10px', fontSize: '25px' }}
          icon={iconeRedeSocial(codigoRede).icon}
          color={iconeRedeSocial(codigoRede).color}
        />
        {`${tituloRede(codigoRede)}`}
      </Heading>
        <div className="row mb-3">
          <div className="col-md-6 mb-4">
          <FormControl isRequired>
          <FormLabel mb="8px">
            {descricaoRede === 'Linkedin' ? 'Nome do aplicativo' : 'Nome do usuário'}
          </FormLabel>
            <CustomInput
              placeholder='Digite um usuário'
              value={formValues.dscUsuario.value}
              onChange={(e) => handleFieldChange('dscUsuario', e.target.value)}
              maxLength={60}
            />
          </FormControl>
          </div>
          {/* <div className="col-md-6 mb-4">
          <FormControl>
          <FormLabel mb="8px">Senha do Usuário</FormLabel>
            <CustomInput
              placeholder='Digite uma senha'
              type={'password'}
              value={formValues.dscSenha.value}
              onChange={(e) => handleFieldChange('dscSenha', e.target.value)}
              maxLength={60}
            />
          </FormControl>
          </div> */}
          {descricaoRede === 'Linkedin' && (
          <div className="col-md-6 mb-4">
            <FormControl>
              <FormLabel mb="8px">Página do Linkedin para publicação</FormLabel>
              <CustomInput
                placeholder="Digite uma página para publicação"
                value={formValues.dscPaginaId.value}
                onChange={(e) => handleFieldChange('dscPaginaId', e.target.value)}
                maxLength={150}
              />
            </FormControl>
          </div>
        )}
          {(descricaoRede === 'Instagram') && (
          <div className="col-md-6 mb-4">
            <FormControl isRequired>
              <FormLabel mb="8px">User ID</FormLabel>
              <CustomInput
                placeholder="Digite o user ID"
                value={formValues.dscPaginaId.value}
                onChange={(e) => handleFieldChange('dscPaginaId', e.target.value)}
                maxLength={150}
              />
            </FormControl>
          </div>
        )}
          {(descricaoRede === 'Facebook') && (
          <div className="col-md-6 mb-4">
            <FormControl isRequired>
              <FormLabel mb="8px">Page ID</FormLabel>
              <CustomInput
                placeholder="Digite o page ID"
                value={formValues.dscPaginaId.value}
                onChange={(e) => handleFieldChange('dscPaginaId', e.target.value)}
                maxLength={150}
              />
            </FormControl>
          </div>
        )}
          <div hidden={descricaoRede === 'Instagram' || descricaoRede == 'Facebook'} className="col-md-6 mb-4">
          <FormControl>
          <FormLabel mb="8px">Chave de API</FormLabel>
            <CustomInput
              placeholder='Digite uma chave'
              value={formValues.dscChaveApi.value}
              onChange={(e) => handleFieldChange('dscChaveApi', e.target.value)}
              maxLength={60}
            />
          </FormControl>
          </div>
          <div hidden={descricaoRede === 'Instagram' || descricaoRede == 'Facebook'} className="col-md-6 mb-4">
          <FormControl>
          <FormLabel mb="8px">Url de redirecionamento autorizada para o aplicativo
          </FormLabel>
            <CustomInput
              placeholder='Digite uma url'
              value={formValues.dscEndpoint.value}
              onChange={(e) => handleFieldChange('dscEndpoint', e.target.value)}
              maxLength={60}
            />
          </FormControl>
          </div>
          <div className="col-md-6 mb-4">
          <FormControl isRequired>
          <FormLabel mb="8px">Token de acesso</FormLabel>
            <CustomInput
              placeholder='Digite um token'
              value={formValues.dscTokenAcesso.value}
              onChange={(e) => handleFieldChange('dscTokenAcesso', e.target.value)}
              maxLength={512}
            />
          </FormControl>
          </div>
        </div>

          <Box alignItems={'flex-end'}>
            <Button type="submit" m="px" onClick={() => navigate(-1)}>
              Desistir
            </Button>
            <Button
              type="submit"
              m="6px"
              color="#FFF"
              bgColor="#1665D8"
              _hover={{ opacity: 0.8 }}
              onClick={() => {
                handleSubmit();
                // navigate(-1);
              }}
              isDisabled={!isFormValid()}
            >
              Salvar
            </Button>
          </Box>
          
        <HelpGuideModal 
        isOpen={isHelpModalOpen} 
        onClose={closeHelpModal} 
        socialMedia={descricaoRede} 
      />
    </Flex>
  )
}

export default ConfigurarMidia;
